import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { LAYOUT_TYPES } from '../../../constants';
import LineTitleGray from '../../atoms/titles/LineTitleGray';
import LinkButton from '../../atoms/button/LinkButton';
import { setCurrentStep, setLayoutType } from '../../../modules/app';
import { useQueryParams } from '../../../utils/queryParams';
import { RtoasterOnComplete } from '../../Head';

const Completed = ({ session }) => {
  const dispatch = useDispatch();
  const query = useQueryParams();
  const { m: memberNumber } = query;

  useEffect(() => {
    dispatch(
      setLayoutType(LAYOUT_TYPES.step)
    );
    dispatch(setCurrentStep(5));

    return () => {
      dispatch(
        setLayoutType(LAYOUT_TYPES.default)
      );
    };
  }, []);

  const pcView = window.innerWidth > 768;
  const rtoasterLabel1 = pcView ? 'rt_pc_kokunai_complete_01' : 'rt_sp_kokunai_complete_01';
  const rtoasterLabel2 = pcView ? 'rt_pc_kokunai_complete_02' : 'rt_sp_kokunai_complete_02';

  const handleMyPage = () => {
    const mypageLink = 'https://mbr.nta.co.jp/ecsystem_portal/view/mypage/mypageTop.html';
    window.open(mypageLink, '_blank');
  };

  return (
    <React.Fragment>
      <RtoasterOnComplete session={session} reservationId={memberNumber} />
      <div className="pageConfirmed">
        <LineTitleGray size="lg">予約完了</LineTitleGray>
        <div className="confirmedBody">
          <p className="textNavy">ご予約ありがとうございます</p>
          <p className="textGray">受付完了のお知らせを送信いたしましたので、必ずご確認ください</p>
          <div className="inquiryNumberBlock">
            <div className="title">お客様番号</div>
            <div className="number">{memberNumber}</div>
            <p className="message">お問い合わせに必要な番号です。大切に保管ください。</p>
          </div>
          <div className="supTexts">
            <p className="supTextGray">マイページよりお申込み内容をご確認いただけます</p>
            <p className="supTextStrong">
              ご出発前に、必ずマイページからeチケットお客様控を印刷または画像を保存し、当日お持ちください<br />
              ※会員のお客様はマイページへログイン後、お名前・郵便番号などの情報登録をお願いします
            </p>
          </div>
          <div className="linkActions">
            <div className="linkMypage">
              <LinkButton buttonType="cta" onClick={handleMyPage}>マイページへ</LinkButton>
            </div>
          </div>
        </div>
      </div>
      <div id={rtoasterLabel1} />
      <div id={rtoasterLabel2} />
    </React.Fragment>
  );
};

Completed.propTypes = {
  session: PropTypes.object,
};

export default Completed;
